module.exports = __webpack_public_path__ + "media/packs/assets/favicon-e041ba97b95b367a84cc1baababdf6f4.ico";